import React, { useState } from 'react'
import { Box, Accordion, AccordionSummary, AccordionDetails, Theme, Button, useMediaQuery } from '@mui/material'
import { makeStyles } from '@mui/styles'
// eslint-disable-next-line import/no-cycle
import { CreateTeamsThreeStageModal } from '../modals'

interface Nomination {
  name: string
  id: number
}

export interface CommandRequestThreeStage {
  nomination: Nomination
  users: {
    email: string
    full_name: string
    id: number
    login: string
    nomination: string
    role: string
  }[]
}

interface Data {
  create_command_2: CommandRequestThreeStage[]
}

const Icon: React.FC<{ className: any; img: any }> = ({ className, img = [] }): JSX.Element => {
  return <img src={img.dropdown} alt="" className={className.icon} />
}

export const TeamsThreeStage: React.FC<{
  data: Data
  updateInfo(): void
  className: any
  img: any
}> = ({ data = {}, updateInfo, className, img = [] }): JSX.Element => {
  const classes = useStyles()
  const [createTeamsModal, setCreateTeamsModal] = useState<CommandRequestThreeStage | undefined>(undefined)
  const [teams, setTeams] = useState<boolean>(false)
  const { create_command_2 } = data

  const sm = useMediaQuery(({ breakpoints: { down } }: Theme) => down(600))

  const handleChangeExTeams = (show: boolean) => {
    setTeams(show)
  }

  return (
    <>
      <CreateTeamsThreeStageModal
        request={createTeamsModal}
        onClose={() => {
          setCreateTeamsModal(undefined)
          updateInfo()
        }}
      />

      <Box className={classes.teams}>
        <Accordion id="teams" expanded={teams} onChange={() => handleChangeExTeams(!teams)} square={false}>
          <AccordionSummary expandIcon={<Icon className={className} img={img} />}>
            Создать команду в Финал Кубка IRB
          </AccordionSummary>
          <AccordionDetails>
            <Box className={className.contentAccordionDetails}>
              <Box mt={1} mb={sm ? '10px' : '14px'}>
                <Box className={classes.text}>
                  Обращаем ваше внимание, что созданная команда автоматически переводится в финал. Создание и перевод в
                  финал других команд в выбранной номинации после этого будет невозможно.
                </Box>
                {create_command_2?.map((i, index) => {
                  return (
                    <Box key={`teams${index}`} mt={2}>
                      <Button
                        variant="contained"
                        color="secondary"
                        className={classes.btn}
                        onClick={() => setCreateTeamsModal(i)}
                        disabled={i.users.length < 4}
                      >
                        Создать команду «{i.nomination.name}»
                      </Button>
                    </Box>
                  )
                })}
              </Box>
            </Box>
          </AccordionDetails>
        </Accordion>
      </Box>
    </>
  )
}

const useStyles = makeStyles(({ font, breakpoints: { down }, palette }: Theme) => ({
  teams: {},
  text: {
    color: palette.secondary.main,
    fontSize: 15,
    fontWeight: 500,
    [down('md')]: {
      fontSize: 14,
    },
    [down('sm')]: {
      fontSize: 13,
    },
  },
  btn: {
    fontSize: '16px!important',
    padding: '10px 30px!important',
    minHeight: '35px!important',
    [down('md')]: {
      fontSize: '15px!important',
      padding: '10px 25px!important',
      minHeight: '30px!important',
      [down('md')]: {
        fontSize: '15px!important',
        padding: '10px 25px!important',
        minHeight: '30px!important',
      },
      [down('sm')]: {
        fontSize: '12px!important',
        padding: '10px 15px!important',
        minHeight: '25px!important',
        minWidth: '10px!important',
      },
    },
  },
}))
